import type { ParseKeys } from 'i18next';

import { HorizontalLineSC, Spacer, theme } from '@dot/design-system';
import { Trans, useTranslation } from 'react-i18next';
import { default as styled } from 'styled-components';

import { fontTextMdRegular } from '@/styles/helpers';

const TextRegular = styled.span`
  ${fontTextMdRegular};
`;

const Ol = styled.ol`
  font-weight: 600;
  padding: 0;
  padding-inline-start: 1.2rem;
  color: ${theme.colors.oxfordBlue[100]};
`;

export const Steps = () => {
  const { t } = useTranslation();

  const texts = [
    t('steps.mobileRedirect.tutorial.steps.step1'),
    t('steps.mobileRedirect.tutorial.steps.step2'),
    t('steps.mobileRedirect.tutorial.steps.step3'),
  ];

  return (
    <Ol>
      {Object.entries(texts).map(([key, val]) => (
        <>
          <li key={key}>
            <Trans
              components={{
                regular_text: <TextRegular />,
              }}
              i18nKey={val as ParseKeys}
            />
          </li>
          <Spacer $bottom={0.75} $top={0.75}>
            <HorizontalLineSC />
          </Spacer>
        </>
      ))}
    </Ol>
  );
};
